export default __webpack_public_path__ + "static/media/BrainBreak cards60.b3752fc4.png";